import React            from 'react';
import PropTypes        from 'prop-types';
// import classNames       from 'classnames';

import Select           from '../../../components/Select';
import Button           from '../../../components/Button';

import Icons            from '../../../../assets/svg/icons.js';

import styles           from '../AccountPage.styl';

const options = [
    {
        id: 'AGENCY',
        name: 'Agency'
    },
    {
        id: 'SERVICES',
        name: 'Services'
    },
    {
        id: 'ECOMMERCE',
        name: 'Ecommerce'
    },
    {
        id: 'MOBILE_APP',
        name: 'Mobile App'
    },
    {
        id: 'OTHER',
        name: 'Other'
    }
]

function CompanyTab(props) {
    const {
        onChangeTab,
        onChangeCase,
        onSelectChange,
        values,
        // errors
    } = props;

    function handleChangeCase(value) {
        return () => {
            onChangeCase(value);
        }
    }

    const { useCase } = values;

    return  (
        <div
            className = {styles.CompanyTab}
        >
            <h2 className={styles.title}>
                Set up your company
            </h2>
            <div className={styles.formBlock}>
                <div className={styles.inputBlock}>
                    <div className={styles.label}>
                        Industry
                    </div>
                    <Select
                        placeholder = 'Select one...'
                        className   = {styles.inputWrapper}
                        options     = {options}
                        value       = {values.organizationIndustry}
                        onChange    = {onSelectChange('organizationIndustry')}
                    />
                </div>
                <div className={styles.inputBlock}>
                    <div className={styles.label}>
                        How will you use Roimax?
                    </div>
                    <div
                        className = {styles.selectBlock}
                        onClick   = {handleChangeCase('AUTOMATE')}
                    >
                        {useCase.includes('AUTOMATE')
                            ? <Icons.CheckboxChecked />
                            : <Icons.CheckboxUnchecked />
                        }
                        <Icons.CampaignAutomate
                            className={styles.selectIcon}
                        />
                        <div className={styles.selectLabel}>
                            {'To automate my Ads'}
                        </div>
                    </div>
                    <div
                        className = {styles.selectBlock}
                        onClick   = {handleChangeCase('ANALYZE')}
                    >
                        {useCase.includes('ANALYZE')
                            ? <Icons.CheckboxChecked />
                            : <Icons.CheckboxUnchecked />
                        }
                        <Icons.CampaignAnalyze
                            className={styles.selectIcon}
                        />
                        <div className={styles.selectLabel}>
                            {'To analyze my Ads'}
                        </div>
                    </div>
                    <div
                        className = {styles.selectBlock}
                        onClick   = {handleChangeCase('LAUNCH')}
                    >
                        {useCase.includes('LAUNCH')
                            ? <Icons.CheckboxChecked />
                            : <Icons.CheckboxUnchecked />
                        }
                        <Icons.CampaignLaunch
                            className={styles.selectIcon}
                        />
                        <div className={styles.selectLabel}>
                            {'To launch new Campaigns'}
                        </div>
                    </div>
                    <div
                        className = {styles.selectBlock}
                        onClick   = {handleChangeCase('OTHER')}
                    >
                        {useCase.includes('OTHER')
                            ? <Icons.CheckboxChecked />
                            : <Icons.CheckboxUnchecked />
                        }
                        <Icons.CampaignKnow
                            className={styles.selectIcon}
                        />
                        <div className={styles.selectLabel}>
                            {'I don\'t know yet'}
                        </div>
                    </div>
                </div>
                <Button
                    className = {styles.button}
                    color     = 'gradient'
                    onClick   = {onChangeTab('congratulations')}
                >
                    Submit
                </Button>
            </div>
        </div>
    );
}

CompanyTab.propTypes = {
    className    : PropTypes.string,
    onChangeCase : PropTypes.func,
    onChangeTab  : PropTypes.func,
    onSelectChange : PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

CompanyTab.defaultProps = {
    className    : '',
    onChangeTab  : () => {},
    onChangeCase : () => {}
};

export default CompanyTab;
